import { connectedStore } from '../../store';
import selectors from '../selectors';

const getScrollPosition = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getScrollPosition(state);
};

export default getScrollPosition;
